import React, { useEffect, useState } from "react";
import { useApply } from "@/context/ApplyContext";
import { CTA_TEXT } from "@/data/content";

export const StickyMobileCta = () => {
  const { openApply } = useApply();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-white/95 backdrop-blur-md border-t border-zinc-200 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <button
        data-testid="sticky-mobile-apply-btn"
        onClick={openApply}
        className="w-full bg-[#D90429] hover:bg-[#B90323] text-white px-6 py-4 rounded-lg font-bold text-base uppercase tracking-wide transition-colors"
      >
        {CTA_TEXT}
      </button>
    </div>
  );
};
